export const formatNgn = (amount) =>
  amount != null && Number.isFinite(Number(amount))
    ? Number(amount).toLocaleString("en-US", { style: "currency", currency: "NGN" })
    : null;

export const getProductDiscountPercent = (product) => {
  const price = Number(product?.price);
  const compareAt = Number(product?.compareAtPrice);
  if (!Number.isFinite(price) || price <= 0) return null;
  if (!Number.isFinite(compareAt) || compareAt <= price) return null;
  return Math.round((1 - price / compareAt) * 100);
};

export const hasProductDiscount = (product) =>
  getProductDiscountPercent(product) != null;

export const validateSlashPrice = (price, compareAtPrice) => {
  if (compareAtPrice == null || compareAtPrice === 0 || compareAtPrice === "") {
    return null;
  }
  const compareAt = Number(compareAtPrice);
  if (!Number.isFinite(compareAt) || compareAt <= 0) {
    return "Slash price must be greater than zero.";
  }
  if (compareAt <= Number(price)) {
    return "Slash price must be higher than the selling price.";
  }
  return null;
};
